export enum HelpContentDisplayType {
  Popup = 'popup',
  NewTab = 'new-tab',
}
